import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/app/resources/$resourceId/')({
  validateSearch: (search: Record<string, unknown>) => ({
    tab: typeof search.tab === 'string' ? search.tab : undefined,
  }),
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/app/resources',
      search: { openResourceId: params.resourceId, tab: search.tab },
    });
  },
});
